import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosPrivate } from '../axios';

// Базовый запрос поверх глобального axiosPrivate:
// подстановка токена и обработка 401 уже подключены интерцепторами в axios.js
const axiosBaseQuery =
  () =>
  async ({ url, method = 'get', ...rest }) => {
    try {
      const result = await axiosPrivate({ url, method, ...rest });
      return { data: result.data };
    } catch (error) {
      return {
        error: {
          status: error.response?.status,
          data: error.response?.data ?? error.message
        }
      };
    }
  };

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['User'],
  endpoints: (builder) => ({
    getUser: builder.query({
      query: (userId) => ({ url: `/users/${userId}` }),
      providesTags: (result, error, userId) => [{ type: 'User', id: userId }]
    })
  })
});

export const { useGetUserQuery } = userApi;
